import { NavLink } from 'react-router-dom';
import { Instagram } from 'lucide-react';
import { contactInfo, navLinks } from '../mock';

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative bg-background border-t border-border px-6 lg:px-10 pt-14 pb-7">
      <div aria-hidden="true" className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-primary via-clay/70 to-transparent" />
      <div className="max-w-[1300px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
          <div className="flex items-center">
            <img
              src="https://customer-assets.emergentagent.com/job_documentation-76/artifacts/iyu3j9j9_Asset%205.png"
              alt="Membratek Membran Yapilar"
              className="h-9 w-auto object-contain"
              draggable="false"
            />
          </div>

          <nav className="flex flex-wrap items-center gap-7">
            {navLinks.map((l) => (
              <NavLink
                key={l.id}
                data-testid={`footer-nav-${l.id}`}
                to={l.to}
                end={l.to === '/'}
                className={({ isActive }) =>
                  `text-[14px] transition ${
                    isActive ? 'text-accent' : 'text-white/65 hover:text-accent'
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <a
            data-testid="footer-instagram-link"
            href="#"
            onClick={(e) => e.preventDefault()}
            className="w-10 h-10 rounded-full border border-border flex items-center justify-center text-white/65 hover:text-accent hover:border-primary/60 transition"
            aria-label="Instagram"
          >
            <Instagram size={16} />
          </a>
        </div>

        <div className="mt-10 pt-6 border-t border-white/5">
          <div data-testid="footer-contact-details" className="text-center text-[12.5px] text-muted-foreground leading-relaxed">
            <span>{contactInfo.phone}</span>
            <span className="mx-3 text-white/20">|</span>
            <span>{contactInfo.emails[0]}</span>
            <span className="mx-3 text-white/20">|</span>
            <span>{contactInfo.address}</span>
          </div>
        </div>

        <div className="mt-7 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div className="text-[12px] text-muted-foreground">
            Membratek Membran Yapilar &copy; 2026 Tum Haklari Saklidir.
          </div>
          <div className="flex items-center gap-5">
            {['KVKK Politikasi', 'Cerez Politikasi', 'Gizlilik Politikasi'].map((p) => (
              <a
                key={p}
                data-testid={`footer-policy-${p.toLowerCase().replace(/\s+/g, '-')}`}
                href="#"
                onClick={(e) => e.preventDefault()}
                className="text-[12px] text-muted-foreground hover:text-accent transition"
              >
                {p}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
